import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  content: {
    [theme.breakpoints.down(Breakpoints.SX_720)]: {
      minHeight: 316
    }
  },
  noContent: {
    color: theme.palette.text.secondary
  },
  placeholder: {
    padding: 16,
    color: theme.palette.text.secondary,
    textAlign: "center"
  }
}));
